export const check_role = (menuslist) => {
    const menus = JSON.parse(localStorage.getItem('menus'));
    return menus.some(function (el) {
        if (menuslist.indexOf(el.slug) !== -1) {
            return true;
        }
    });
}

// export default date_format;